import theme from "@/styles/theme";
import {
  Box,
  DialogTitle,
  type DialogTitleProps,
  Typography,
} from "@mui/material";

type Props = DialogTitleProps & {
  title: string;
  subtitle?: string;
};

export function Header({ title, subtitle, children, sx, ...rest }: Props) {
  return (
    <DialogTitle
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: 3,
        paddingRight: 6,
        paddingBottom: 2,
        ...sx,
      }}
      {...rest}
    >
      <Box>
        <Typography variant={"h6"} color={theme.palette.raip.main}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant={"body2"} sx={{ opacity: 0.8 }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {children}
    </DialogTitle>
  );
}
